/**
 * Text that carries merge fields (`{{ claim_reference }}`), shown as a reader
 * sees it: the words, with each field as a quiet tag ("claim reference")
 * rather than template syntax. For subjects in the composer and the template
 * library; the field is filled in from the record when the message is sent.
 */
import { Fragment } from 'react'

/** `{{ claim.number }}` -> "claim number"; filters and dots read as words. */
function fieldLabel(token: string): string {
  return token
    .replace(/[{}]/g, '')
    .split('|')[0]
    .trim()
    .replace(/[._]/g, ' ')
}

export function MergeFieldText({
  text,
  className = '',
}: {
  text: string
  className?: string
}) {
  const parts = text.split(/(\{\{[^}]*\}\})/g).filter(Boolean)
  return (
    <span className={className}>
      {parts.map((part, index) =>
        part.startsWith('{{') ? (
          <span
            key={index}
            className="mx-0.5 rounded-[3px] bg-[var(--bg-subtle)] px-1 py-px text-[0.92em] text-[var(--ink-3)]"
          >
            {fieldLabel(part)}
          </span>
        ) : (
          <Fragment key={index}>{part}</Fragment>
        ),
      )}
    </span>
  )
}
